// HEADER
jQuery(function($) {
    $( document ).ready(function() {
  
        handleMenuBurger();
        handleMenuSticky();
        changeButtonsColor();

        function handleMenuBurger() {

            var body = document.querySelector('body');
            var mobileBurger = document.querySelector('.mobile-burger');
            var closeMenuMobile = document.querySelector('.close-mobile-menu');
            var headerMenuMobile = document.querySelector('.main__header--mobile');

            mobileBurger.addEventListener('click' , function() {
                headerMenuMobile.classList.add('open');
                body.style.overflow = "hidden";
            })
            closeMenuMobile.addEventListener('click' , function() {
                headerMenuMobile.classList.remove('open');
                body.style.overflow = "initial";
            })

        }

        function handleMenuSticky() {

            var menuSticky = document.querySelector('.topmenu-mobile');
            if (menuSticky){

                var dropBtn = menuSticky.querySelector('.dropbtn');
                dropBtn.addEventListener('click', function() {
                    menuSticky.classList.toggle('open');
                })
            }

        }
        function changeButtonsColor(){
            const buttons = document.querySelectorAll('.dropdown-content > a')
            const stayBtn = document.querySelector('#stay-with-us-btn')
            const color = window.getComputedStyle(stayBtn).getPropertyValue("background-color")
            // console.log(color);
            buttons.forEach(b => {
                b.style.backgroundColor = color
                
            })
        }
  
    });
  });